import activityFeedReducer from "./activity-feed/reducers";
import avatarsReducer from "./avatars/reducers";
import fileUploaderReducer from "./file-uploader/reducers";
import guestListReducer from "./guestlist/reducers";
import photosReducer from "./photos/reducers";
import pollsReducer from "./polls/reducers";
import rsvpReducer from "./rsvp/reducers";
import slideshowReducer from "./slideshow/reducers";
import sponsoredRegistryReducer from "./sponsored-registry/reducers";
import whatToBringReducer from "./what-to-bring/reducers";

import { combineReducers, compose } from 'redux';
import { createStore, applyMiddleware } from 'redux'


// Combine Reducers
// Here we combine reducers into a single object to be used in the store.
// Important, non-obvious note: The shape of the reducers forms the shape of
// the store.
// http://redux.js.org/docs/api/combineReducers.html
const eventViewReducer = combineReducers({
  activityfeed:       activityFeedReducer,
  avatars:            avatarsReducer,
  fileupload:         fileUploaderReducer,
  guestlist:          guestListReducer,
  photos:             photosReducer,
  polls:              pollsReducer,
  rsvp:               rsvpReducer,
  slideshow:          slideshowReducer,
  sponsoredregistry:  sponsoredRegistryReducer,
  whattobring:        whatToBringReducer
});

// Crash reporting Redux middleware for sentry:
// https://blog.sentry.io/2016/08/24/redux-middleware-error-logging.html

// It would be nice to send state (with extra) but our state is too large...
// This is also the reason why we cannot use the nicer RavenMiddleware:
// https://blog.sentry.io/2016/08/24/redux-middleware-error-logging.html#redux-and-sentry
const reduxCrashReporter = store => next => action => {
  try {
    return next(action); // Dispatch action
  } catch (err) {
    Raven.captureException(err, {
      extra: {
        action
      }
    });
    throw err;
  }
}

// The devToolsExtension line enables chrome redux-devtools if installed:
// https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Store
// A store is the application state, composed of the reducer(s)
// http://redux.js.org/docs/basics/Store.html
const store = createStore(eventViewReducer, composeEnhancers(
  applyMiddleware(reduxCrashReporter)
));

export default store;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/store.es6